/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API50744Req {
  
  /** 任务id */
  taskId?: number;
  /** 关联的任务id */
  linkTaskId?: number;
  /** 关联类型,link_task=关联，pre_task=前置任务 */
  linkType?: string;
};



export interface API50744Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 50744 新增关联任务

export interface IUsePostAPI50744Return {
  /** 新增关联任务: 接口请求状态 */
  isAPI50744Loading: boolean;
  /** 新增关联任务: 接口请求返回数据 */
  dataAPI50744: API50744Res;
  /**  新增关联任务: 接口数据请求方法 */
  fetchAPI50744Data:  (inputs: API50744Req, config?: YWRequestConfig) => Promise<API50744Res>;
  /** 新增关联任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI50744 = ():IUsePostAPI50744Return => {
  let isMount = true;
  const [isAPI50744Loading, setIsAPI50744Loading] = useState(false);
  const [dataAPI50744, setDataAPI50744] = useState<API50744Res>({} as API50744Res);
  const requestUrl = `${basePath}/team-work/workTask/link/add`;

  const fetchAPI50744Data = async (inputs: API50744Req, config?: YWRequestConfig): Promise<API50744Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50744Req>) || {}) as API50744Req;
    
  
    if ( isMount ) {
      setIsAPI50744Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API50744Res>(`${basePath}/team-work/workTask/link/add`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI50744(res || {} as API50744Res);
        setIsAPI50744Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50744Loading(false);
      }
      return false as unknown as API50744Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50744Loading,
    dataAPI50744,
    fetchAPI50744Data,
    requestUrl,
  }
}

